import { forwardRef, useEffect, useState } from 'react';

const Video = forwardRef(({ video, onEnded, style, ...rest }: any, ref: any) => {
  const [src, setSrc]: any = useState(null);

  const fetchVideo = function (url: string) {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = function (e) {
      if (this.status === 200) {
        setSrc(URL.createObjectURL(this.response));
      }
    };
    xhr.send();
  };

  useEffect(() => {
    if (video.blob) {
      fetchVideo(video.src);
    } else {
      setSrc(video.src);
    }
  }, [video]);

  return (
    <video
      src={`${src}`}
      muted={true}
      style={{ ...video.style, ...style }}
      onEnded={(e: any) => {
        if (onEnded) onEnded(e);
      }}
      ref={ref}
      loop={video.loop ? true : false}
      autoPlay={video.autoPlay ? true : false}
      poster={video.poster}
      // preload="auto"
      playsInline
      {...rest}
      x-webkit-airplay="allow"
      t7-video-player-type="inline"
      x5-playsinline=""
      x5-video-player-type="h5"
      webkit-playsinline=""
    />
  );
});

export default Video;
